export default __webpack_public_path__ + "static/media/pich-profile.fad805e4.jpg";